import { USER_ROLE } from "./constants";

export const getIsRoleReadOnly = (noAdminSites, selectedRole) => noAdminSites || selectedRole?.toLowerCase() === USER_ROLE.ADMIN;

export const getIsNotAdmin = (selectedRole) => selectedRole?.toLowerCase() === USER_ROLE.SITE_MANAGER || selectedRole?.toLowerCase() === USER_ROLE.SITE_VIEWER;

export const isMDNModified = (newMDN, originalMDN) => {
  const cleanMDN = (mdn) => (mdn ? mdn.replace(/[^0-9]/g, "") : "");
  return cleanMDN(originalMDN) !== cleanMDN(newMDN);
};

export const USER_DETAILS_TOOLTIP_EDIT_PHONE_ONLY = "You are only allowed to edit your phone number";
export const USER_DETAILS_TOOLTIP_EDIT_OWN_PROFILE = "You can edit your name and phone number";
export const USER_DETAILS_BUTTON_EDIT = "Edit Details";
export const USER_DETAILS_BUTTON_SAVE = "Save Details";
export const USER_DETAILS_BUTTON_RESEND_INVITE = "Resend Invite";
export const USER_DETAILS_LINK_VIEW_USERS_ON_ACCOUNT = "View users on account";

// Field names for notifications
export const USER_DETAILS_FIELD_FIRST_NAME = "First name";
export const USER_DETAILS_FIELD_LAST_NAME = "Last name";
export const USER_DETAILS_FIELD_PHONE_NUMBER = "Phone number";
export const USER_DETAILS_FIELD_ROLE = "Role";
export const USER_DETAILS_FIELD_SITES = "Sites";
export const USER_DETAILS_FIELD_GROUPS = "Groups";

// Group removal messages
export const GROUP_REMOVED_SUCCESS = "Group removed successfully";
export const GROUP_REMOVAL_FAILED = "Failed to remove group, please try again";
export const GROUP_REMOVED_SUCCESS_PREFIX = "User";
export const GROUP_REMOVED_SUCCESS_MIDDLE = "removed from group";
export const GROUP_REMOVED_SUCCESS_SUFFIX = "successfully.";

// Shared modal buttons
export const MODAL_CONFIRM_REMOVE_BUTTON = "Yes, remove";
export const MODAL_CANCEL_BUTTON = "Cancel";

// Shared remove modal message
export const REMOVE_MODAL_MESSAGE_PREFIX = "Are you sure you want to remove user";

// Remove group modal
export const REMOVE_GROUP_MODAL_TITLE = "Remove user from group?";
export const REMOVE_GROUP_MODAL_MESSAGE_SUFFIX = "from group";

// Add group modal
export const ADD_GROUP_MODAL_TITLE_PREFIX = "Add user";
export const ADD_GROUP_MODAL_TITLE_SUFFIX = "to Groups";
export const ADD_GROUP_MODAL_SITE_LABEL = "Site:";
export const ADD_GROUP_MODAL_BUTTON = "Add selected groups";
export const ADD_GROUP_MODAL_NO_GROUPS_MESSAGE = "No groups available for this site.";
export const ADD_GROUP_MODAL_NO_MEMBERS_MESSAGE = "No members in this group.";

// Cancel modal
export const CANCEL_MODAL_TITLE = "Are you sure you want to cancel?";
export const CANCEL_MODAL_MESSAGE = "Any unsaved changes will be lost.";
export const CANCEL_MODAL_CONFIRM_BUTTON = "Yes";
export const CANCEL_MODAL_CANCEL_BUTTON = "No";

// Remove site modal
export const REMOVE_SITE_MODAL_TITLE = "Remove user from site?";
export const REMOVE_SITE_MODAL_MESSAGE_SUFFIX = "from site";
export const REMOVE_SITE_MODAL_SAVE_NOTE = 'This change will take effect when you click "Save Details".';

// Aggregate notification messages
export const USER_DETAILS_UPDATE_SUCCESS_SUFFIX = "updated successfully";
export const USER_DETAILS_UPDATE_FAILED_PREFIX = "Failed to update";

// Tooltip messages
export const ADD_GROUP_TOOLTIP = "Add group";
export const ADD_GROUP_NO_PERMISSION_TOOLTIP = "You don't have permission to add groups";
export const ADD_GROUP_SETTINGS_TOOLTIP = "User groups must be managed from the User Group Settings tab";
export const DELETE_SITE_TOOLTIP = "Delete site";
export const DELETE_SITE_NO_PERMISSION_TOOLTIP = "You don't have permission to delete site.";
export const DELETE_SITE_NO_AUTH_TOOLTIP = "You do not have permission to delete a site";
export const BILLING_ACCOUNT_NO_PERMISSION_TOOLTIP = "You don't have permission to modify billing accounts.";

// Permission strings
export const PERMISSION_ROLE_MANAGEMENT = "Role management";

// Default fallback labels
export const DEFAULT_SITE_LABEL = "Site";
export const DEFAULT_GROUP_LABEL = "Group";

// Section titles
export const SITES_AND_GROUPS_SECTION_TITLE_PREFIX = "Sites & Notification Groups (";
export const SITES_AND_GROUPS_SECTION_TITLE_SUFFIX = "is associated with)";

// Navigation delay
export const NAVIGATION_DELAY = 4 * 1000; // 4 seconds delay before navigation to allow notification to render

// Promise status
export const PROMISE_STATUS_FULFILLED = "fulfilled";

// Billing account modal
export const BILLING_ACCOUNT_MODAL_TITLE = "Users on Billing Account";
export const BILLING_ACCOUNT_MODAL_LABEL = "Billing Account:";
export const BILLING_ACCOUNT_MODAL_NO_USERS = "No users found on this billing account.";
export const BILLING_ACCOUNT_MODAL_CLOSE_BUTTON = "Close";

// OTP modal
export const OTP_MODAL_TITLE = "Check your phone";
export const OTP_MODAL_MESSAGE_PREFIX = "We've sent a passcode to";
export const OTP_MODAL_MESSAGE_SUFFIX = "to confirm that this is the correct phone number.";
export const OTP_MODAL_ERROR_MESSAGE = "Invalid OTP. Please enter a valid 6-digit code.";
export const OTP_MODAL_RESENDING = "Resending...";
export const OTP_MODAL_RESEND_CODE = "Resend code";
export const OTP_MODAL_VERIFYING = "Verifying...";
export const OTP_MODAL_SUBMIT = "Submit";

// Error messages
export const USER_DETAILS_UPDATE_ERROR = "Failed to update user details. ";
export const FETCH_USERS_LIST_ERROR = "Failed to fetch users list, please reload the page.";

// Resend invite messages
export const RESEND_INVITE_SUCCESS_MESSAGE = "Resent invite to {firstname} {lastname} to add them to your organization.";
export const RESEND_INVITE_ERROR_MESSAGE = "Failed to resend invite. Please try again.";
export const INVALID_EMAIL_ERROR_MESSAGE = "Invalid email address. Cannot resend invite.";

// Notification types (banners)
export const NOTIFICATION_TYPE_RESEND_INVITE = "Resend Invite";
export const NOTIFICATION_TYPE_INVITE_SENT = "Invite sent";
export const NOTIFICATION_TYPE_UPDATED_INVITE_SENT = "Updated invite sent";
export const NOTIFICATION_TYPE_USER_DETAILS_NOT_UPDATED = "User details not updated";

// Notification priorities
export const NOTIFICATION_PRIORITY_SUCCESS = "success";
export const NOTIFICATION_PRIORITY_CRITICAL = "critical";
export const NOTIFICATION_PRIORITY_WARNING = "warning";

// Modal names for resetModal function
export const MODAL_NAME_ADD_GROUP = "addGroup";
export const MODAL_NAME_BILLING = "billing";
export const MODAL_NAME_CANCEL = "cancel";
export const MODAL_NAME_REMOVE_GROUP = "removeGroup";
export const MODAL_NAME_REMOVE_SITE = "removeSite";
export const MODAL_NAME_OTP = "otp";
